import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface AuthRouteProps {
  children: React.ReactNode
}

const FIRST_VISIT_KEY = 'hasVisitedBoot'

// 检查token是否有效的函数
const isTokenValid = (token: string | null): boolean => {
  if (!token) return false
  
  try {
    return token.trim().length > 0
  } catch (error) {
    console.error('Token validation error:', error)
    return false
  }
}

// 检查用户是否已登录
const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token')
  return isTokenValid(token)
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const location = useLocation()
  
  // 检查 URL 参数中是否有 token（用于外部链接跳转登录）
  const searchParams = new URLSearchParams(location.search)
  const urlToken = searchParams.get('token')
  const hasUrlToken = urlToken !== null && urlToken.trim().length > 0
  
  // ⚠️ 关键修复：如果 URL 中携带了 token，必须优先处理，跳过所有其他检查
  // 即使 localStorage 中已经有 token（刚保存的），也要让 Login 页面完成验证流程
  if (hasUrlToken) {
    // 立即保存 token 到本地存储
    localStorage.setItem('token', urlToken)
    
    // 自动标记已访问过引导页，避免后续被重定向
    localStorage.setItem(FIRST_VISIT_KEY, 'true')
    
    // 如果不在登录页面，重定向到登录页面（保留 token 参数）
    if (location.pathname !== '/login') {
      return <Navigate to={`/login?token=${urlToken}`} replace />
    }
    
    // 如果已经在登录页面，直接渲染，让它完成验证和跳转
    return <>{children}</>
  }
  
  // 如果已登录且 URL 没有 token，才重定向到首页
  // 这样可以避免在 token 登录过程中被重定向
  if (isAuthenticated() && !hasUrlToken) {
    // 获取之前想要访问的页面，如果没有则跳转到首页
    const from = (location.state as any)?.from?.pathname || '/home'
    return <Navigate to={from} replace />
  }

  // 如果未登录，检查是否需要先访问引导页
  const hasVisitedBoot = localStorage.getItem(FIRST_VISIT_KEY)
  if (!hasVisitedBoot && location.pathname !== '/boot') {
    // 未访问过引导页且当前不在引导页，强制重定向到引导页
    return <Navigate to="/boot" replace />
  }

  // 如果未登录且已访问过引导页，正常渲染认证相关页面
  return <>{children}</>
}

export default AuthRoute